<template>
	<div id="chat" :class="view" class="custom-chat">
		<ImagePopup
			:active.sync="imagePopupActive"
			:file.sync="imagePopupFile"
		/>
		<FullTextPopup
			:active.sync="textPopupActive"
			:message.sync="fullTextMessage"
		/>
		<div class="head">
			<div class="manager" v-if="!orderId && collocutor.role !== 'order' &&  collocutor.role !== 'author'">
				<div class="info">
					<strong class="name">{{ collocutor.name }}</strong>
					<span v-if="collocutor.role === 'client'" class="role">{{getUserRole(collocutor.role) }}</span>
					<span v-else class="role">{{ $t('chatWithYourManager(p1)') }} <b>{{ $t('chatWithYourManager(p2)') }}</b></span>
				</div>
			</div>
			<div class="info" v-else>
				<span>
					<template v-if="collocutor.role === 'author'">
						<span>{{ $t('chatWithAuthor') }}</span>.
						{{ $t('order') }}
						<strong class="name">№ {{ collocutor.orderId }}</strong>
					</template>
					<template v-else>
						{{ $t('chatByOrder') }}
						<strong class="name">№ {{ orderId || collocutor.orderId }}</strong>
					</template>
				</span>
			</div>
			<div class="buttons">
				<vs-button class="fullSize" @click="view = view === 'full' ? 'mini' : 'full'">
					<svg width="22" height="20" x="0" y="0" class="stencil--easier-to-select" style="opacity: 1;">
						<defs></defs>
						<rect x="0" y="0" width="22" height="20" fill="transparent"
							  class="stencil__selection-helper"></rect>
						<path
							d="M19.555555555555557 0C19.555555555555557 0 2.4444444444444446 0 2.4444444444444446 0 1.094415055969172 0 0 1.119288125423017 0 2.5 0 2.5 0 17.5 0 17.5 0 18.88071187457698 1.094415055969172 20 2.4444444444444446 20 2.4444444444444446 20 19.555555555555557 20 19.555555555555557 20 20.900000000000002 20 22 18.875 22 17.5 22 17.5 22 2.5 22 2.5 22 1.119288125423017 20.905584944030828 0 19.555555555555557 0 19.555555555555557 0 19.555555555555557 0 19.555555555555557 0M19.555555555555557 17.5C19.555555555555557 17.5 2.4444444444444446 17.5 2.4444444444444446 17.5 2.4444444444444446 17.5 2.4444444444444446 5 2.4444444444444446 5 2.4444444444444446 5 19.555555555555557 5 19.555555555555557 5 19.555555555555557 5 19.555555555555557 17.5 19.555555555555557 17.5 19.555555555555557 17.5 19.555555555555557 17.5 19.555555555555557 17.5"
							stroke-width="0" stroke="none" stroke-dasharray="none" fill="rgb(98, 98, 98)"
							fill-rule="evenOdd"></path>
					</svg>
				</vs-button>
				<vs-button class="turn" @click="$store.dispatch('hideChat')">
					<svg width="20" height="20" x="0" y="0" class="stencil--easier-to-select" style="opacity: 1;">
						<defs></defs>
						<rect x="0" y="0" width="20" height="20" fill="transparent"
							  class="stencil__selection-helper"></rect>
						<path
							d="M20 2.014285714285715C20 2.014285714285715 17.985714285714288 0 17.985714285714288 0 17.985714285714288 0 10 7.985714285714285 10 7.985714285714285 10 7.985714285714285 2.014285714285715 0 2.014285714285715 0 2.014285714285715 0 0 2.014285714285715 0 2.014285714285715 0 2.014285714285715 7.985714285714285 10 7.985714285714285 10 7.985714285714285 10 0 17.985714285714288 0 17.985714285714288 0 17.985714285714288 2.014285714285715 20 2.014285714285715 20 2.014285714285715 20 10 12.014285714285716 10 12.014285714285716 10 12.014285714285716 17.985714285714288 20 17.985714285714288 20 17.985714285714288 20 20 17.985714285714288 20 17.985714285714288 20 17.985714285714288 12.014285714285716 10 12.014285714285716 10 12.014285714285716 10 20 2.014285714285715 20 2.014285714285715"
							stroke-width="0" stroke="none" stroke-dasharray="none" fill="rgb(98, 98, 98)"
							fill-rule="evenOdd"></path>
					</svg>
				</vs-button>
			</div>
		</div>

		<div class="body custom-chat-body">
			<div class="search">
				<vx-input-group>
					<div class="vs-component vs-con-input-label vs-input vs-input-primary">
						<div class="vs-con-input">
						</div>
						<vs-input class="inputx" placeholder="" v-model="searchInput"/>
					</div>
					<template slot="append">
						<div class="append-text btn-addon">
							<vs-button
								color="primary"
								placeholder=""
								type="filled"
								@click="search = searchInput"
							>{{ $t('search') }}</vs-button>
						</div>
					</template>
				</vx-input-group>
			</div>
			<VuePerfectScrollbar
				ref="verticalNavMenuPs"
				:key="$vs.rtl"
				:settings="settings"
				@ps-scroll-y="psSectionScroll"
				@scroll="psSectionScroll"
				class="scroll-area-v-nav-menu"
			>
<!--				<transition name="fade">-->
					<div>
						<div class="day" v-for="day in filteredList">
							<span class="date">{{ day.created | moment('YYYY-MM-DD') }}</span>
<!--							<transition-group name="flip-list">-->
								<template v-for="(message, index) in day.messages">
									<div
										v-if="message.type === 'system'"
										class="system-message flex justify-center text-center break-words hyphens-auto p-4 bold"
									>
										<MessageBody :text="message"  @sendFile="sendFile"/>
									</div>
									<div class="message"
										 :key="message.id"
										 v-else-if="message.type !== 'system'"
										 :class="{isManager: !message.is_my_message}"
									>
										<div class="top">
											<div class="author">
												<div class="avatar">
													<img
														v-if="message.user.photo"
														:src="filePath(message)"
														alt=""
													>
													<feather-icon icon="UserIcon" class="client-avatar" />
												</div>
												<div class="name">
													<strong>{{ getUserName(message) }}</strong>
													<div class="role">
														{{ message.user.role !== 'client' ? getUserRole(message.user.role) : " " }}
													</div>
												</div>
											</div>
											<div class="time">
												{{ message.created | moment('HH:mm:ss A') }}
													<feather-icon
												 		v-if="message.has_full_text"
														icon="MoreHorizontalIcon"
													 	svgClasses= "w-6 h-6"
														class="feather-icon"
														@click="showFullText(message)"
													/>
											</div>

										</div>
										<p class="main">
											<MessageBody
												@openImagePopup="openImagePopup"
												:collocutor="collocutor"
												:text="message"
												@sendFile="sendFile"
											/>
										</p>
									</div>
<!--									<div class="info" v-else :key="message.id">-->
<!--										<span v-html="message.message"></span>-->
<!--									</div>-->
								</template>
<!--							</transition-group>-->
						</div>
					</div>
<!--				</transition>-->
				<div ref="endOfMessages"></div>
			</VuePerfectScrollbar>
		</div>
		<div v-if="disabled" class="bottom-panel"></div>
		<div v-else-if="integratedWithIntercom" class="bottom-panel">
			<vs-alert relief  color="danger">
				<div class="pb-2 mb-3 text-center text-bold">
					Chat in readonly mode. Order conversation moved to Intercom
				</div>
			</vs-alert>

		</div>
		<div
			v-else
			class="send"
		>
			<vx-input-group>
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<div class="vs-con-input">
					</div>
					<TextEditor
						v-model="msg"
						name="about"
						class="card-ticket__about"
					/>
<!--					<vs-input-->
<!--						class="inputx"-->
<!--						placeholder=""-->
<!--						v-model="msg"-->
<!--						@keydown.enter="addMessage"-->
<!--					/>-->
				</div>
			</vx-input-group>
			<div
				v-if="pendingFiles.length"
				class="pending-files mt-3"
				:class="{ 'pending-files--scrollable': pendingFiles.length > 3 }"
			>
				<div
					v-for="(pendingFile, index) in pendingFiles"
					:key="`${pendingFile.name}-${index}`"
					class="pending-files__item"
				>
					<feather-icon icon="PaperclipIcon" class="pending-files__icon" />
					<span class="pending-files__name">{{ pendingFile.name }}</span>
					<feather-icon
						icon="XIcon"
						class="pending-files__remove"
						@click="removePendingFile(index)"
					/>
				</div>
			</div>
			<div class="d-flex justify-end mt-5">
				<vs-button
					color="primary"
					@click="addMessage"
					class="flex-grow"
					:disabled="disableSendButton"
					type="filled">{{ $t('send') }}
				</vs-button>
				<vs-button
					v-if="allowSendViaESputnik"
					color="primary"
					@click="addMessageSputnik"
					class="ml-5"
					:disabled="disableSendButton"
					type="filled">{{ $t('firstEmailReply') }}
				</vs-button>
				<vs-button
					v-if="$store.state.auth.role === 'manager' || $store.state.auth.role === 'author'"
					color="success"
					@click="markAsRead"
					type="filled"
					class="ml-5"
					:disabled="disableButton"
				>
					{{ $t('markAsRead') }}
				</vs-button>
				<div class="d-inline-block">
					<div class="d-flex full-height">
						<label class="file-input self-align-center">
							<div class="file-input__container" style="width: 37px">
								<feather-icon class="file-input__img" icon="PaperclipIcon" />
							</div>
							<input multiple
								   ref="fileInput"
								   type="file"
								   class="hidden"
								   @input="selectFiles"
								   accept=".jpg,.jpeg,.png,.xls,.xlsx,.docx,.doc,.odt,.rtf,.pdf,.txt,.csv,.zip,.pages,.sav,.MP4,.MOV,.MPG,.AVI,.M4V,.3GP,.3GGP,.MX20,.MX18,.MX12,.r,.ppt,.pptx"
							>
						</label>
					</div>
				</div>
				<vs-dropdown
					v-if="canShowTemplateMessages"
					vs-custom-content
					vs-trigger-click
					vs-collapse
					:fixed="true"
					class="circle cursor-pointer"
					icon="MoreHorizontalIcon"
				>
					<vs-button
						@click="addMessage"
						color="primary"
						type="filled"
						class="flex justify-center items-center"
					>
						<feather-icon icon="MoreHorizontalIcon" class="flex items-center"/>
					</vs-button>

					<vs-dropdown-menu
						:fixed="true"
						class="chat-template-messages"
					>
            <vs-input
              v-model="templateSearchText"
              :label="$t('searchByName')"
              class="chat-template-messages__input"
              icon="search"
              icon-after
              @input="updateTemplateMessages"
            />

						<VuePerfectScrollbar
						  v-if="quickMessages.length > 0" class="chat-template-messages__container"
            >
							<vs-dropdown-item
                v-for="item in quickMessages"
                :key="item.id"
                @click="msg = item.message"
              >
								{{ item.name }}
							</vs-dropdown-item>
						</VuePerfectScrollbar>

            <div v-else class="chat-template-messages__empty">
              {{ $t('emptyList') }}
            </div>
					</vs-dropdown-menu>
				</vs-dropdown>
				<span v-if="getIsIntercomAvailable" class="intercom-spacer"/>
			</div>
		</div>
	</div>
</template>

<script>
import ImagePopup from "@/components/dialogs/ImagePopup";
import FullTextPopup from "@/components/dialogs/FullTextPopup";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import MessageBody from './MessageBody';
import FeatherIcon from "@/components/FeatherIcon";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import TextEditor from "@/components/text-editor/TextEditor";
import debounce from "debounce";
import {mapGetters} from "vuex";

// let updatingInterval = null;

export default {
	name: "Chat",
	mixins: [databaseManager, notifier],
	components: {
		TextEditor,
		FeatherIcon,
		MessageBody,
		VuePerfectScrollbar,
		ImagePopup,
		FullTextPopup
	},

  data() {
    return {
      view: 'mini', // mini, full
      search: '',
      searchInput: '',
      msg: '',
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 1,
        swipeEasing: true
      },
      updatingInterval: null,
      chatObserver: null,
      messages: [],
      quickMessages: [],
      isVisible: 0,
      unreadMessages: null,

      imagePopupActive: false,
      imagePopupFile: null,

      textPopupActive: false,
      fullTextMessage: '',
      templateSearchText: '',
	  allowSendViaESputnik: false,
	  integratedWithIntercom: false,
	  pendingFiles: [],
	  isSending: false,
    }
  },

	watch: {
		searchInput(newValue) {
			if(newValue === "") {
				this.search = "";
			}
		},
		$route (){
			this.$store.dispatch('hideChat')
    	}
	},
	computed: {
		...mapGetters([
			"getIsIntercomAvailable",
		]),
		disableSendButton() {
			return (!this.hasMessageText && this.pendingFiles.length === 0) || this.isReadOnly || this.isSending;
		},
		hasMessageText() {
			return this.msg.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length > 0;
		},
		isReadOnly() {
			return this.integratedWithIntercom;
		},
		verticalNavMenu() {
			return this.$refs.verticalNavMenuPs;
		},
		orderId() {
			const payload = this.$store.state.chat.payload;
			if(!payload || !payload.id) return null;
			return 	payload.id;
		},
		disabled() {
			return this.$store.state.chat.disabled;
		},
		collocutor() {
			return this.$store.state.chat.collocutor;
		},
		filteredList() {
			if (!this.search) {
				const scrollToBottom = this.isVisible;
				this.scrollToBottom(scrollToBottom);
				return this.messages;
			}

			const result = Object.values(this.messages).map(post => {
				let messages = post.messages.filter(message => {
					if (message.message.toLowerCase().includes(this.search.toLowerCase())) {
						return message
					}
				})
				if (messages.length > 0) {
					return {
						created: post.created,
						messages
					}
				} else return null
			}).filter(e => e !== null);

			if(result.length !== 0) {
				this.scrollToBottom(false);
			}

			return result;
		},
		canShowTemplateMessages() {
			return this.$store.state.auth.role === 'admin'
				|| this.$store.state.auth.role === 'manager'
		},
		disableButton() {
			if (this.unreadMessages === null) return false
			if (this.collocutor.role === 'author' && !this.unreadMessages.unread_author_chat) {
				return true
			} else if (this.collocutor.role === 'order' && !this.unreadMessages.unread_author_chat) {
				return true
			} else if (this.collocutor.role === undefined && !this.unreadMessages.unread_client_chat) {
				return true
			} else if (this.collocutor.role === 'client' && !this.unreadMessages.unread_client_chat) {
				return true
			}
			return false
		},
		getClientId() {
			return this.$route.query.userId
		}
	},
	methods: {
		async showFullText(message) {
			const id = message.id
			try {
				const res = await this.dbGetFullMessage(id)
				this.textPopupActive = true
				this.fullTextMessage = res.message
			} catch (e) {
				this.notifyError(e.message)
			}
		},

		openImagePopup(e, file) {
			if (file.message.toLowerCase().includes('jpeg') ||
				file.message.toLowerCase().includes('jpg') ||
				file.message.toLowerCase().includes('png') ||
				file.message.toLowerCase().includes('svg')
			) {
				e.preventDefault()
				this.imagePopupActive = true
				this.imagePopupFile = file
			}
		},
		async sendFile(file) {
			try {
				await this.$http.post(`${this.$store.state.auth.role}/order/add-file`, {
					order_id: this.orderId,
					file_id: file.id
				})
				this.notifySuccess(this.$t('addedSuccessfully'));

				this.$root.$emit('fileAddedToOrder', this.orderId);

			} catch (e) {
				this.notifyError(e.message)
			}
		},
		getUserRole(role) {
			if(role === "manager") {
				return this.$t('manager');
			} else if(role === "author") {
				return this.$t('copywriter');
			} else if(role === "admin") {
				return this.$t('admin');
			} else if(role === "client") {
				return this.$t('client');
			}

			return "";
		},
		scrollToBottom(isImportant = true) {
			this.$nextTick(() => {
				if(isImportant !== true) return;

				const endOfMessages = this.$refs.endOfMessages

				let count = 0;
				for(let day of Object.values(this.filteredList)) {
					count += day.messages.length;
				}

				if(endOfMessages !== null) {
					endOfMessages.scrollIntoView(false);
				} else {
					this.$refs.verticalNavMenuPs.$el.scrollTop = 1000000;
				}
			});
		},
		checkIfAtTheBottom() {
			if(this.$refs.verticalNavMenuPs === undefined) return true;
			const scrollbar = this.$refs.verticalNavMenuPs.$el;
			return Math.floor(scrollbar.scrollHeight - scrollbar.scrollTop) === scrollbar.clientHeight;
		},
		psSectionScroll() {
			const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs
			this.showShadowBottom = scroll_el.scrollTop > 0
		},
		revers(array){
			return array.reverse();
		},
		async updateMessage(clearInput = true, scrollToBottom = false) {
			let data = this.$store.state.chat.messages;

			if(data.length > 0){
				let messages = {};
				data.forEach( curr=> {
					let date = curr.created.split(' ')[0];
					if(messages[date])
						messages[date].messages.push(curr);
					else {
						messages[date] = {};
						messages[date].messages = [];
						messages[date].created = curr.created;
						messages[date].messages.push(curr)
					}
				})

				Object
					.values(messages)
					.forEach(e=>e.messages.reverse());

				this.messages = Object
					.keys(messages)
					.sort()
					.reduce((r, k) => (r[k] = messages[k], r), {})
			}

			if(clearInput) {
				this.msg = '';
			}
			this.scrollToBottom(scrollToBottom);
		},
		filePath(message) {
            let file
            if (message.user_creator) file = message.user_creator.photo
            if (message.user && !message.user_creator) file = message.user.photo
			if (!file) {
				return;
			}

			const fileName = file.toLowerCase();
			return fileName;
		},
        getUserName(message) {
            if (message.user_creator) return message.user_creator.username
            if (message.user && !message.user_creator) return message.user.username
        },
		async uploadMessage(message, sendViaEsputnik = false, files = []) {
			this.scrollToBottom(true)
			try {
				const msg = message;
				await this.$store.dispatch('sendMessage', { msg, sendViaEsputnik, files });

				setTimeout(() => this.loadMessages(), 100);

			} catch (error) {
				this.notifyError(error.message)
			}
		},
		addMessage() {
			this.sendMessage(false);
		},
		addMessageSputnik() {
			this.sendMessage(true);
		},
		selectFiles() {
			const selected = Array.from(this.$refs.fileInput.files || []);
			selected.forEach(file => {
				// Keep a stable File reference for later FormData upload
				this.pendingFiles.push({
					file,
					name: file.name,
					size: file.size,
					type: file.type,
				});
			});
			this.$refs.fileInput.value = '';
		},
		removePendingFile(index) {
			this.pendingFiles.splice(index, 1);
		},
		async sendMessage(sendViaEsputnik = false) {
			if (!this.hasMessageText && this.pendingFiles.length === 0) {
				return;
			}

			this.isSending = true;
			this.scrollToBottom(true);

			try {
				const idChat = this.$store.state.chat.idChat;
				let files = [];

				if (this.pendingFiles.length > 0) {
					const filesToUpload = this.pendingFiles.map(item => item.file);
					const totalFiles = filesToUpload.length;
					const uploadedFiles = await this.dbUploadMany(filesToUpload, idChat);
					const successfulUploads = uploadedFiles.length;

					if (this.$store.state.auth.role === 'author') {
						uploadedFiles.forEach(el => {
							el.fullUrl = process.env.VUE_APP_API_HOST + el.url;
						});
					}

					files = uploadedFiles.map(el => ({
						url: el.fullUrl,
						path: el.url,
					}));

					if (successfulUploads < totalFiles) {
						this.notifyError(
							this.$t('uploadWarning', { success: successfulUploads, total: totalFiles })
						);
					}
				}

				await this.uploadMessage(this.msg, sendViaEsputnik, files);
				this.msg = '';
				this.pendingFiles = [];
			} catch (e) {
				const message = (e.response && e.response.message)
					|| e.message
					|| this.$t('notAllowedFileType');
				this.notifyError(message);
			} finally {
				this.isSending = false;
			}
		},
		async markAsRead() {
			try {
				await this.$http.post(`/chat/set-read/${this.$store.state.chat.idChat}`)
			} catch (e) {
				this.notifyError(e.message)
			}
		},
		async loadChatAdditionalInfo() {
			if(this.orderId) {
				const order = await this.dbViewOrder(this.orderId);
				this.allowSendViaESputnik = order.is_esputnik_allowed;
				console.log(order.intercom)
				console.log(order.intercom && order.intercom.enabled && order.intercom.ticket_id)
				this.integratedWithIntercom = order.intercom && order.intercom.enabled && order.intercom.ticket_id;
			}

		},
		async loadMessages(scrollToBottom = false) {
			if(this.updatingInterval !== null) clearInterval(this.updatingInterval);

			if (this.$store.state.auth.role !== 'client' && this.$route.params.id !== undefined) {
				this.unreadMessages = await this.dbCheckMessagesStatus(this.$route.params.id)
			} else if (this.getClientId !== null && this.getClientId !== undefined) {
				try {
					const res = await this.$http.get(`${this.$store.state.auth.role}/client/get-chat-statuses/${this.getClientId}`);
					this.unreadMessages = res.data.data
				} catch (e) {
					console.log(e.message);
				}
			}

			let res = await this.$store.dispatch('getMessages');
			const isScroll = scrollToBottom || this.isVisible;

			if(res === undefined) return;
			await this.updateMessage(false, isScroll);

			this.updatingInterval = setInterval(() => this.loadMessages(), 180000);
		},
		setChatObserver() {
			let options = {
				root: this.$refs.verticalNavMenuPs.$el,
				rootMargin: '5px',
				threshold: 1
			}
			let callback = (entries, observer) => {
				entries.forEach(entry => {
					this.isVisible = entry.isIntersecting;  // intersecting: true or false
				});
			};
			this.chatObserver = new IntersectionObserver(callback, options);

			this.chatObserver.observe(this.$refs.endOfMessages)
		},

    async getTemplateMessages() {
      if (!this.canShowTemplateMessages) {
        return
      }

      const { idChat } = this.$store.state.chat

      try {
        this.quickMessages = await this.dbGetChatTemplateMessages({
          id: idChat,
          query: this.templateSearchText,
        })
      } catch (err) {
        this.notifyError(err.message)
      }
    },

    updateTemplateMessages: debounce(async function() {
      await this.getTemplateMessages()
    }, 300),
	},

	async mounted() {
    	await this.getTemplateMessages()

		this.loadMessages(true);

		this.setChatObserver();
		this.loadChatAdditionalInfo();
	},

	beforeDestroy() {
		this.$router.replace({ path: this.$router.path })

		clearInterval(this.updatingInterval);
		this.updatingInterval = null;
		if (this.chatObserver !== null) {
			this.chatObserver.disconnect()
		}

	},
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/functions";
@import "../../assets/scss/vuexy/variables";

.flip-list-move {
	transition: transform 1s;
}

.flip-list-enter, .flip-list-leave-to {
	opacity: 0;
}

.fade-enter-active, .fade-leave-active {
	transition: opacity 1s;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}

.con-vs-dropdown--menu {
	z-index: 999999;
}

#chat {
	width: 700px;
	border-radius: 8px;
	border: 2px solid #e4e4e4;
	background-color: #fff;
	overflow: hidden;
	position: fixed;
	bottom: 0;
	left: calc(100% - 700px);
	z-index: 999998;
	max-height: 100%;
	//transition: 0.5s;
	//transform: translate(0);

	// .tox.tox-tinymce{
	// 	height:300px !important;
	// 	@media (max-height: 900px){
	// 		height: 250px;
	// 	}
	// 	@media (max-height: 800px){
	// 		height: 200px !important;
	// 	}
	// 	@media (max-height: 650px){
	// 		height: 150px !important;
	// 	}
	// }
	.ps-container {
		padding: 0 16px;
	}

	.ps-container {
		height: 280px;

		@media (max-height: 900px){
			height: 200px;
		}
		@media (max-height: 800px){
			height: 200px;
		}
		@media (max-height: 650px){
			height: 100px;
		}
	}

	&.full {
		left: 0;
		width: 100vw;
		height: 100vh;
		border-radius: 0;

		.ps-container {
			height: 53vh;
		}

		.send {
			position: relative;
			width: 100%;
			bottom: 0;
			left: 0;
			z-index: 999;
			background-color: #fff;
		}
	}

	.head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 5px 16px;
		border-bottom: 2px solid #e4e4e4;


		.manager {
			display: flex;
			align-items: center;

			.photo {
				display: flex;
				align-items: center;
				margin-right: 10px;
			}

			.info {
				display: flex;
				flex-direction: column;
				font-size: rem(16px);

				.name {
					font-size: rem(16px);
					display: flex;
					flex-direction: column;
					justify-content: center;
					line-height: 1;
				}
			}
		}

		.buttons {
			.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
				padding: 8px;
				background-color: transparent !important;

				&--background {
					display: none !important;
				}
			}

			svg path {
				transition: .25s;
			}

			.vs-button:hover {
				background-color: transparent !important;
				box-shadow: none;

				svg path {
					fill: $primary;
				}
			}

			.vs-button.isActive {
				background-color: transparent !important;
			}
		}
	}

	.body {
		background-color: #e8eaf6;
		padding-bottom: 20px;

		.search {
			padding: 10px 16px 0 16px;
		}

		.date {
			width: 100%;
			display: inline-block;
			text-align: center;
			padding-bottom: 20px;
			padding-top: 10px;
		}

		.message {
			background-color: #fff;
			border-radius: 8px;
			padding: 9px;
			width: 89%;
			margin-bottom: 20px;
			margin-left: auto;
			box-shadow: 0px 2px 5px 0px #0000001f;

			&:last-child {
				margin-bottom: 0;
			}

			&.isManager {
				margin-left: 0;
			}

			.main {
				padding-top: 7px;
				word-break: break-word;
				hyphens: auto;
				a {
					&:hover {
						text-decoration: underline;
						cursor: pointer;
					}
				}
			}

			.author {
				display: flex;
				align-items: center;
				padding-bottom: 5px;

				.avatar {
					margin-right: 10px;
					width: 40px;
					height: 40px;
					overflow: hidden;
					border-radius: 100%;

					img {
						max-width: 100%;
						height: 100%;
						width: 100%;
					}
				}

				.client-avatar {
					display: flex;
					justify-content: center;
					align-items: center;
					border-radius: 100%;
					width: 100%;
					height: 100%;
					//background-color: #eaeaea;
					background-color: #42A5F5;
					color: white;

					svg {
						width: 75%;
						height: 75%;
					}
				}

				.name {
					font-size: rem(16px);
					display: flex;
					flex-direction: column;
					justify-content: center;
					line-height: 1;
				}
			}

			.top {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				border-bottom: 2px solid #d6d6d6;
			}

			.time {
				font-weight: 500;
				font-size: rem(12px);
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				.feather-icon {
					cursor: pointer;
				}
			}
		}

		.info {
			text-align: center;
			padding-bottom: 20px;

			&:last-child {
				padding-bottom: 0;
			}
		}
	}

	.bottom-panel {
		width: 100%;
		height: 45px;
		background: #fff;
	}

	.send {
		padding: 7px 16px 10px 16px;
		//display: flex;

		.pending-files {
			display: flex;
			flex-direction: column;
			gap: 6px;

			&--scrollable {
				max-height: 132px;
				overflow-y: auto;
				padding-right: 4px;
			}

			&__item {
				display: flex;
				align-items: center;
				gap: 8px;
				padding: 6px 10px;
				border-radius: 6px;
				background-color: #f3f4f6;
				flex-shrink: 0;
			}

			&__icon {
				width: 16px;
				height: 16px;
				color: $primary;
				flex-shrink: 0;
			}

			&__name {
				flex: 1;
				font-size: rem(13px);
				word-break: break-all;
			}

			&__remove {
				width: 16px;
				height: 16px;
				cursor: pointer;
				flex-shrink: 0;
			}
		}

		&.disabled {
			display: none;
		}

		.vx-input-group {
			width: 100%;
		}

		.file-input {
			border-radius: 100%;
			margin-left: 10px;
			display: flex;
			justify-content: center;
			align-items: center;
			//flex: 37px 0 0;
			width: 37px;
			height: 37px;
			overflow: inherit;
			padding: 0;
			background-color: $primary;
			cursor: pointer;

			&__container {
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 100%;
				padding: 0;
				width: 100%;
				height: 100%;
			}

			&__img {
				width: 22px;
				height: 22px;
				color: white;
			}
		}

		.circle button {
			overflow: hidden;
			width: 37px;
			height: 37px;
			flex-shrink: 0;
			text-align: center;
			padding: 0;
			border-radius: 100%;
			margin-left: 10px;
		}
	}
}
@media screen and (min-width: 361px ) and (max-width: 500px) {
	#chat {
		right: 0;
		left: auto;
		width: 100%;
		height: 100vh;
		.tox.tox-tinymce{
			height:200px !important;
		}
		.send{
			overflow: auto;
		}
	}
	.ps-container {

		height: 230px !important;
	}
}
@media screen and (max-width: 360px) {
	#chat {
		right: 0;
		left: auto;
		width: 100%;
		height: 100vh;
		.tox.tox-tinymce{
			height:200px !important;
		}
		.send{
			overflow: auto;
			.vx-input-group {
				div.tox.tox-tinymce {
					height: 130px !important;
				}
			}
		}
	}
	.ps-container {
		height: 150px !important;
	}
}
.custom-chat {
	display: flex;
	flex-direction: column;
	height: 100vh;

	&-body {
		flex: 1 0 auto;
		display: flex;
		flex-direction: column;

		.day {
			padding-bottom : 5px;
		}
	}

	.scroll-area-v-nav-menu {
		flex: 1 0 auto;
		margin-top: 10px;
		padding: 0 16px 20px 16px;
		overflow-y: scroll !important;
		&::-webkit-scrollbar {
			appearance: none;
			width: 0;
		}
	}
}

.chat-template-messages {
	z-index: 999999 !important;
	width: 300px !important;
  height: 350px !important;

  .vs-dropdown--custom {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  &__input {
    width: 100% !important;
    padding: 0 5px 10px;

    .vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0 !important;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}
  }

	&__container {
		overflow-y: auto;
    max-height: 300px;
	}

  &__empty {
    padding: 10px;
    text-align: center;
  }
}
.full-height {
	height: 100%
}
.self-align-center {
	align-self: center;
}
.intercom-spacer {
	width: 95px;
	height: 45px;
}
.system-message, .message {
	ul, ol {
		padding-left: 20px !important;
	}
	ul {
		list-style: unset;
	}
}
.message {
	pre {
		text-wrap: unset;
	}
	s {
		text-decoration: line-through;
	}
	ol {
		list-style-type: revert;
	}
}
</style>
